import { updatePaymentItemSchema, zSchema } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export type TUpdatePaymentItemRequest = zSchema.infer<
  typeof updatePaymentItemSchema
>;

export type TUpdatePaymentItemResponse = TUpdatePaymentItemRequest & {
  paymentItemID: string;
};

export const updatePaymentItem = (axios: IAxiosInstance) => {
  return async (requestBody: TUpdatePaymentItemRequest) => {
    const response = await axios.noRetry.patch<
      IApiResponse<TUpdatePaymentItemResponse>
    >("payment-items", requestBody);
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
